export const facebookClientId =
  import.meta.env.REACT_APP_FACEBOOK_CLIENT_ID || '';
export const linkedinClientId =
  import.meta.env.REACT_APP_LINKED_IN_CLIENT_ID || '';
export const instagramBasicClientId =
  import.meta.env.REACT_APP_INSTAGRAM_BASIC_CLIENT_ID || '';
